import React from "react";
import NavBar from "../components/public/NavBar";
import Footer from "../components/public/Footer";

const PublicLayout = props => {
  
  const classes = {
    'main-content': {
      marginTop: '1rem',
      background: '#f3f4fa',
      minHeight: '40rem',
    }
  }

	return (
    <>
      <NavBar/>
      <div style={classes["main-content"]}>
        {props.children}
      </div>
      <Footer/>
    </>
	);
};

export default PublicLayout;
